import { createBrowserHistory, createHashHistory } from 'history';
import isClient from 'helpers/isClient';

export default isClient ? createBrowserHistory() : null;

export const hashHistory = isClient ? createHashHistory() : null;
